import React from "react";
import { DropdownItem } from "Components/ReactstrapSlim";

import dropdownClasses from "./ClearDropdown.module.scss";
import classes from "./SolutionsDropdown.module.scss";

interface CategoryListProps {
   title: string;
   items: {
      title: string;
      href: string;
   }[];
}

const CategoryList: React.FC<CategoryListProps> = ({ title, items }) => {
   return (
      <div className={classes.category}>
         <div className={classes.categoryTitle}>{title}</div>
         <div className={classes.categoryItems}>
            {items.map((item) => (
               <DropdownItem
                  cssModule={dropdownClasses}
                  key={item.title}
                  title={item.title}
                  className={classes.categoryLink}
                  href={item.href}
               >
                  {item.title}
               </DropdownItem>
            ))}
         </div>
      </div>
   );
};

export default CategoryList;
